import { CSSTransition } from "react-transition-group";

import styled, { css } from "styled-components";
import tw from "twin.macro";

import { BoxSizingStyle } from "../BoxSizingStyle";
import { FontStyle } from "../FontStyle";

export const StyledSignifier = styled.div<{ $direction: string }>`
  ${tw`tw-inline-flex tw-items-center tw-text-theme-800`}
  ${FontStyle}
  ${BoxSizingStyle}

  cursor: default;

  ${(props) =>
    props.$direction === "c-signifier--top" &&
    css`
      --signifier-in: 60%;
      --signifier-out: -60%;
    `}

  ${(props) =>
    props.$direction === "c-signifier--bottom" &&
    css`
      --signifier-in: -60%;
      --signifier-out: 60%;
    `}
`;
StyledSignifier.displayName = "StyledSignifier";

export const StyledSignifierTransition = styled(CSSTransition)`
  &.c-signifier--animate-enter {
    opacity: 0;
    transform: translateY(var(--signifier-in));
  }
  &.c-signifier--animate-enter-active {
    opacity: 1;
    transform: translateY(0%);
    transition-duration: 300ms;
  }
  &.c-signifier--animate-exit {
    transform: translateY(0%);
    opacity: 1;
  }
  &.c-signifier--animate-exit-active {
    transform: translateY(var(--signifier-out));
    opacity: 0;
    transition-duration: 300ms;
  }
`;
StyledSignifierTransition.displayName = "StyledSignifierTransition";

export const StyledIcon = styled.svg`
  ${tw`tw-text-xs tw-mr-1`}
`;
StyledIcon.displayName = "StyledIcon";
